var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 42C7 22.67 22.67 7 42 7C61.33 7 77 22.67 77 42C77 61.33 61.33 77 42 77C22.67 77 7 61.33 7 42Z",
    fill: "#36B37E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3797 34.4197C53.4732 35.5132 53.4732 37.286 52.3797 38.3795L41.1797 49.5795C40.0862 50.673 38.3134 50.673 37.2199 49.5795L31.6199 43.9795C30.5264 42.886 30.5264 41.1132 31.6199 40.0197C32.7134 38.9262 34.4862 38.9262 35.5797 40.0197L39.1998 43.6398L48.4199 34.4197C49.5134 33.3262 51.2862 33.3262 52.3797 34.4197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.fbaa7c75d15beb9bfcf99d292420be4e.svg";
export { ForwardRef as ReactComponent };